import ApiService from "../api.service";
const UzexService = {
    GetAllAuctionOblast() {
    return ApiService.get(`/Uzex/GetAllAuctionOblast`);
  },
  GetAllAuctionRegion(OblastId) {
    return ApiService.get(`/Uzex/GetAllAuctionRegion?OblastId=${OblastId}`);
  },
  ProviderCard(ProviderId,providertin){
    return ApiService.get(`/Uzex/ProviderCard?ProviderId=${ProviderId}&providertin=${providertin}`)
  },
  BuyerCard(BuyerId,BuyerTin){
    return ApiService.get(`/Uzex/BuyerCard?BuyerId=${BuyerId}&BuyerTin=${BuyerTin}`)
  },
  DashboardByCategory(StartDate,EndDate,isDashboard){
    return ApiService.get(`/Uzex/DashboardByCategory?StartDate=${StartDate}&EndDate=${EndDate}&isDashboard=${isDashboard}`)
  },
  GetAllUzexItemGroup(){
    return ApiService.get(`/Uzex/GetAllUzexItemGroup`)
  },
  GetLotInfo(id){
    return ApiService.get(`/Uzex/GetLotInfo?id=${id}`)
  }
};
export default UzexService;
